
  export const STREAKS_RECEIVED = "STREAKS_RECEIVED";
  export const SET_STREAK = "SET_STREAK";
  export const CREATE_STREAK = "CREATE_STREAK";
  export const SET_PROPERTY_STREAK = "SET_PROPERTY_STREAK";
  